import { render, staticRenderFns } from "./ModifyPass.vue?vue&type=template&id=267b9cef&scoped=true&"
import script from "./ModifyPass.vue?vue&type=script&lang=js&"
export * from "./ModifyPass.vue?vue&type=script&lang=js&"
import style0 from "./ModifyPass.vue?vue&type=style&index=0&id=267b9cef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267b9cef",
  null
  
)

export default component.exports